import React, { Component } from "react";
import examsService from "../../services/ExamsService";
import LoadDNA from "../LoadDNA";
import {
  FETCH_INTERVAL,
  STAGE_COLOR_CODE,
  STAGE_ICONS,
  STAGE_SHORT,
} from "../../constants";
import { sendEvent } from "../../util/utils";
import moment from "moment";
import UserService from "../../services/UserService";

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      examHistory: {},
      loading: true,
      exam: null,
      hasPendencies: false,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.startGettingHistoryData(this.props.exam);
    this.setState({ loading: false });
    sendEvent("reset-map-zoom");
  }

  componentWillUnmount() {
    this.stopGettingData();
  }

  stopGettingData() {
    examsService.stopGettingDataFrom("getHistory");
  }

  async startGettingHistoryData(exam) {
    examsService.stopGettingDataFrom("getHistory");
    this.setState({
      exam: exam,
    });

    await examsService.startGettingDataFrom(
      "getHistory",
      exam,
      this.updateExamHistory.bind(this),
      FETCH_INTERVAL
    );
  }

  updateExamHistory(examHistory) {
    this.setState({
      examHistory: examHistory,
    });
    examHistory && examHistory.map(phase =>{
      if((phase.pendency && phase.pendency.length > 0) ||
         (phase.sampleRecall && phase.sampleRecall.length > 0)
      ){
        this.setState({hasPendencies: true});
      }
    })
    sendEvent("draw-history", {
      examHistory: examHistory,
      productionUnit: this.state.exam?.productionUnit,
      examName: `${this.state.exam?.mnMat}|${this.state.exam?.mnExa}`,
    });
  }

  async getExamResult(exam) {
    let year = exam && exam.orderDate.split("-");
    year = year && year.length > 0 && year[0];

    if (
      exam &&
      exam.orderId &&
      exam.examId &&
      year &&
      exam.patientName &&
      exam.examDescription
    ) {
      let result = await examsService.getResult(
        exam.orderId,
        exam.examId,
        year
      );

      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const downloadLink = document.createElement("a");
        const fileName = `${exam.patientName} - ${exam.examDescription}.pdf`;

        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    }
  }

  openAccordion(stageName){
    let element = document.getElementById(stageName);
    if(element){
      element.classList.toggle('active');
      let panel = element && element.nextElementSibling;
      
      if(panel && panel.style){
        if (panel.style.display === 'none' || !panel.style.display) {
          panel.style.display = 'block';
        } else {
          panel.style.display = 'none';
        }
      }
    }
  }

  renderDialogBody(data,stageName){
    if(data){
      return (
        <div className="exam-info-header" style={{boxShadow: 'none'}}>
          <div className="row g-6 mb-3">
            <div className="col">
              <div className="exam-data">
                <div className="exam-data-title">
                  Data/Hora
                </div>
                <div className="exam-data-content exam-data-date">
                  {moment(data.dateHourAction).format("DD/MM/YYYY HH:mm") || '-'}
                </div>
              </div>
            </div>
            <div className="col">
              <div className="exam-data">
                <div className="exam-data-title">
                  Situação
                </div>
                <div className={`exam-data-content exam-data-status data-status-${STAGE_ICONS[stageName.toUpperCase()]}`}>
                  {STAGE_SHORT[stageName.toUpperCase()]}
                </div>
              </div>
            </div>
          </div> 
          <div className="row mb-3">
            <div className="col">
              <div className="exam-data">
                <div className="exam-data-title">
                  Requerido
                </div>
                <div className="exam-data-content">
                  {data.userAction || '-'}
                </div>
              </div>
            </div>
            <div className="col">
              <div className="exam-data">
                <div className="exam-data-title">
                  Descrição
                </div>
                <div className="exam-data-content">
                  {data.descriptionAction || '-'}
                </div>
              </div>
            </div>
          </div> 
          <div className="row mb-3">
            <div className="exam-data">
              <div className="exam-data-title">
                Detalhes
              </div>
              <div className="exam-data-content exam-data-date pb-1" style={{whiteSpace: 'normal'}}>
                {data.fullDetail || '-'}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="exam-data">
              <div className="exam-data-title">
                Observações
              </div>
              <div className="exam-data-content exam-data-date">
                {data.note || '-'}
              </div>
            </div>
          </div>
        </div>
    )
    }
  }
  render() {

    return (
      <>
        <div className="row" style={{ marginBottom: "5px" }}>
          <div className="col">
            <div
              className="link-back"
              onClick={() => this.props.backListExam()}
            >
              Voltar
            </div>
          </div>
        </div>
        {this.state.loading ? (
          <LoadDNA width={"150px"} />
        ) : (
          <div className="exam-info-container">
            <div className="exam-info-header">
              <div className="exam-container-header">
                <div
                  className="exam-info-name"
                  data-bs-toggle="tooltip"
                  title={this.props.exam.examDescription}
                >
                  {this.props.exam.examDescription}
                </div>
                {this.props.exam.urgency && !this.props.exam.urgency !== "" ? (
                  <div className="exam-urgent">Urgente</div>
                ) : null}
                {this.props.exam.sampleStored.toUpperCase()=="SIM" ? (
                  <div 
                    className='exame-armazenado'
                    data-bs-toggle="tooltip" 
                    title="Exame Armazenado" 
                    data-bs-original-title="Exame armazenado">Armazenado</div>
                ):(
                  <>
                  {this.props.exam.discardedSample !== "" && (
                    <div 
                      className='exame-descartado'
                      data-bs-toggle="tooltip" 
                      title={
                        this.props.exam.discardedSample.replace('!','.')
                      }
                      data-bs-original-title={
                        this.props.exam.discardedSample.replace('!','.')
                      }>Descartado</div>
                  )}
                  </>
                )}
                {this.props.exam.eventStage === "Resultado Liberado" && (
                  <div
                    className="exam-report"
                    data-bs-toggle="tooltip"
                    title="Baixar resultado do exame"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.getExamResult(this.props.exam);
                    }}
                    >
                    Download
                  </div>
                )}
              </div>

              <div className="row exam-patient-row">
                <div className="col-5">
                  <div className="exam-data">
                    <div className="exam-data-title">Pedido</div>
                    <div
                      className="exam-data-content exam-data-date"
                      style={{ fontWeight: "normal !important" }}
                      data-bs-toggle="tooltip" 
                      title={
                        `${this.props.exam.orderId} (${this.props.exam.orderAlphaNumeric})`
                      }
                      data-bs-original-title={
                        `${this.props.exam.orderId} (${this.props.exam.orderAlphaNumeric})`
                      }
                    >
                    {`${this.props.exam.orderId} (${this.props.exam.orderAlphaNumeric})`}
                    </div>
                  </div>
                </div>
                <div className="col-7">
                  <div
                    className="exam-data"
                  >
                    <div className="exam-data-title">Paciente</div>
                    <div 
                      className="exam-data-content patient-name" 
                      data-bs-toggle='tooltip' 
                      title={this.props.exam.patientName}>
                      {this.props.exam.patientName}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row exam-data-row">
                {UserService.getUserType() !== "PSC" ? (
                  <div className="col-5" >
                    <div className="exam-data">
                      <div className="exam-data-title">Unidade</div>
                      <div className="exam-data-content exam-data-date">
                        {this.props.exam.aliasProdUnit}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="col" >
                  <div className="exam-data">
                    <div className="exam-data-title">Previsão</div>
                    <div 
                      className={`exam-data-date exam-data-content ${this.props.exam.rescheduled && "exame-remarcado"}`}
                      data-bs-toggle="tooltip" 
                      title={this.props.exam.rescheduled} 
                      data-bs-original-title={this.props.exam.rescheduled}
                    >
                      {this.props.exam.estimatedResultDate
                        ? moment(this.props.exam.estimatedResultDate).format(
                            "DD/MM/YY HH:mm"
                          )
                        : "Pendente"}
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="exam-data">
                    <div className="exam-data-title">Situação</div>
                    <div
                      className={`exam-data-content exam-data-status data-status-${
                        STAGE_ICONS[this.props.exam.eventStage.toUpperCase()]
                      }`}
                      style={
                        UserService.getUserType() === "PSC"
                          ? {overflow: "visible"}
                          : {}
                      }
                    >
                      {STAGE_SHORT[this.props.exam.eventStage.toUpperCase()]}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="exam-info-steps">
              {this.state.examHistory &&
                this.state.examHistory.map((phase, index) => {
                  let pendencies = phase.pendency || phase.sampleRecall || null;
                  return <>
                  <div
                    className={(pendencies && pendencies.length > 0) ?
                      `accordion exam-info-step exam-info-step-status-${
                      STAGE_ICONS[phase.stageName.toUpperCase()]}`:
                      `exam-info-step exam-info-step-status-${
                      STAGE_ICONS[phase.stageName.toUpperCase()]}`
                    }
                    onClick={pendencies ? ()=> this.openAccordion(phase.stageName): ()=>{}}
                    id={phase.stageName}
                  >
                    <div className="row mb-10">
                      <div className="col">
                        <span className="exam-info-step-status">
                          {(index+1)+" - "+STAGE_SHORT[phase.stageName.toUpperCase()]}
                        </span>
                      </div>
                      <div className="col-auto">
                        {!phase.dateHour ? (
                          <span className="exam-info-step-date-time">
                            Pendente
                          </span>
                        ) : (
                          <span className="exam-info-step-date-time" style={this.state.hasPendencies ? {marginRight: 22}: {}}>
                            {moment(phase.dateHour).format("DD/MM/YYYY HH:mm")}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {pendencies ? 
                    <div className="panel-accordion">
                      <ul style={{listStyleType: 'none', padding: 0, marginBottom: 0}}>
                        {pendencies.map((pendency)=>(
                          <div className="exam-info-step" style={{paddingTop: 10}}>
                            <div className="row mb-10">
                              <div className="col exam-step-pendency-info">
                                <span 
                                  className="exam-info-step-date-time"
                                  data-bs-toggle="tooltip"
                                  title={pendency.reason}
                                >
                                  {pendency.reason}
                                </span>
                              </div>
                              <div className="col-auto">
                                <span style={{marginRight: 22}}>
                                  {moment(pendency.dateHourAction).format("DD/MM/YYYY HH:mm")}
                                </span>
                              </div>
                            </div>
                            <span 
                              className="show-password"
                              style={{width: 35, height: '100%', backgroundSize: '22px 22px'}}
                              data-bs-toggle='tooltip'
                              title="Ver detalhes"
                              onClick={()=> sendEvent('show-dialog', {
                                title: pendency.reason,
                                child: this.renderDialogBody(pendency, phase.stageName), 
                                show: true,
                                confirmation: () => {
                                  sendEvent("show-dialog", { show: false });
                                },
                              })}
                            >
                            </span>
                          </div>
                        ))}
                      </ul>
                    </div>
                    :null
                  }
                  </>
                })}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default History;
